<template lang="pug">
div
    app-nav
    .row
        .col-sm-1
        .col-sm-6
            h1 {{title}}
                small &nbsp;
            p  Astreinte à partir du 1/1/2019...
    .row
        .col-sm-1
        .col-sm-6
            
            router-link(class="btn btn-primary my-4 " :to="{name: 'GardesNew'}") Nouvelle liste
            .row
                table.table.table-striped
                    thead
                        tr
                            th Num
                            th Date
                            th
                            th 
                            th 
                            th   
                    tbody       
                        tr(v-for="liste in allListes.edges" :key="liste.node.id")
                            td
                                router-link( :to="{name: 'Garde' , params: { id: liste.node.id }}") {{liste.node.id}}      
                            td {{moment(liste.node.date).format("YYYY")}}
                            td  {{moment(liste.node.date).format("MMMM")}}
                            td
                                router-link(type="button" class='btn btn-primary btn-sm pull-right' :to="{name: 'GardesEdit' , params: { id: liste.node.id }}") Editer
                            td
                       
                            td
                                button.btn.btn-danger.pull-right.btn-sm( type="submit" @click="deleteListe(liste.node.id)") Supprimer   
        .col-xs-12.col-sm-4 
            p.lead= sidebar
            p 
                img(src="/static/fatigue1.png" width="400" height=auto)
</template>
<script>
import AppNav from './AppNav'
import { 
  ALL_GARDES,
  DELETE_LISTE,
  GARDE_BY_ID_QUERY 
  } from '../constants/gardes'
import moment from 'moment'
export default {
    name: 'gardes',
    components: {
        AppNav,
    },
    data() {
        return {
            moment: moment,
            allListes: [],
            title: 'Les gardes/astreintes'
        }
    },
    apollo: {
        allListes: {
            query: ALL_GARDES
        }
    },
    methods: {
      deleteListe(id){
        this.$apollo.mutate({
        mutation: DELETE_LISTE,
        variables: {
            id: id           
        },
        refetchQueries: [{
            query: ALL_GARDES
        }]           
        }).then((data) =>{

        }).catch((error) => {
        // Error
        console.error(error)
        })
    }
  }
}
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// gardes.vue?049f9097